// LoadingState.jsx
// Loading state component for ViewMyListings

import React from 'react';
import { styles } from './styles';

const LoadingState = () => {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.loadingSpinner}></div>
      <div style={styles.loadingText}>Loading your listings...</div>
    </div>
  );
};

export default LoadingState;